/*eslint-disable */

import Vue from 'vue'
import {
  bus
} from '@/main';
import {
mapGetters,
} from 'vuex';

var $ = window.jQuery = require('jquery');


export default {
  name: 'algo-all-user-data',
  components: {
  },
  props: [],
  data () {
    return {
      algoDataList:{},
      algoDataListResults:[],
      createAlgoDataPopup:false,
      updateAlgoDataPopup:false,
      updateAlgoDataId:'',
      userDetails:{},
      is_superuser:false,
      is_guestuser:false
    }
  },
  computed: {
    ...mapGetters([
      'getAllUserAlgoDataListGetters',
      'acUserDetailsStateGetters',
    ]),
    getAlgoDataListFun(){
      this.algoDataList = this.$store.getters.getAllUserAlgoDataListGetters.data;
      return
    },
    setIntialsOfDataState(){
      if(this.algoDataList != undefined){
        this.algoDataListResults = this.algoDataList.results
      }
    },
    getUserDetailsAgainFun() {
      this.userDetails = this.$store.getters.acUserDetailsStateGetters.data
      return
    },
    SetIntialSuperUserStatus(){
      if (this.userDetails != undefined) {
        this.is_superuser = this.userDetails.is_superuser
        this.is_guestuser = this.userDetails.guest
      }
      return
    }
  },
  mounted () {
    this.getAlgoDataListFun
    this.setIntialsOfDataState
    bus.$on('createAlgoDataPopupBus', (data) => {
      this.createAlgoDataPopup = data;
    });
    bus.$on('updateAlgoDataPopupBus', (data) => {
      this.updateAlgoDataPopup = data;
    });
    this.getUserDetailsAgainFun
    this.SetIntialSuperUserStatus
  },
  methods: {
  },
  watch:{
    getAlgoDataListFun(){
      return this.$store.getters.getAllUserAlgoDataListGetters
    },
    setIntialsOfDataState(){
      if(this.algoDataList != undefined){
        this.algoDataListResults = this.algoDataList.results
      }
    },
    getUserDetailsAgainFun() {
      return this.$store.getters.acUserDetailsStateGetters.data
    },
    SetIntialSuperUserStatus(){
      if (this.userDetails != undefined) {
        this.is_superuser = this.userDetails.is_superuser
        this.is_guestuser = this.userDetails.guest
      }
      return
    }
  }
}